import "./Nutrition.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Nutrition from "./sections/Nutrition";
import Articles from "./sections/Articles";
import Footer from "@/reusable_sections/Footer";
export default function NutritionPage() {
  return <div>
      <Header />
      <Intro />
      <Nutrition />
      <Articles />
      <Footer />
    </div>;
}